import { useContext } from 'react'
import { RoomContext, RoomContextType } from '../RoomContext'
import { UserContext, UserContextType } from '../UserContext'
import { isNullMediaDeviceId } from '../utils'
import { ModifiedLiveKitAudioRenderer } from '../UIComponents/ModifiedLiveKitAudioRenderer'

export default function LocalLoopbackRenderer() {
    const { state } = useContext(UserContext) as UserContextType
    const { state: roomState } = useContext(RoomContext) as RoomContextType

    if (isNullMediaDeviceId(state.mediaSelection.audioOutput)) {
        return null
    }

    const id = `mediaStreamID=__localLoopbackAudioStream__,sinkId=${state.mediaSelection.audioOutput}`
    const sinkId = state.clientType === 'listenonly' ? 'default' : state.mediaSelection.audioOutput
    const track = roomState.localLoopbackAudioLivekitTrack

    if (track) {
        return <ModifiedLiveKitAudioRenderer key={id} id={id} track={track} isLocal={false} sinkId={sinkId} />
    }

    return null
}
